import React from 'react';
import {
  Table, Button, Modal, Icon,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';

const ListRow = () => allFiles => {
  const processResponse = record => {
    return (
      <div>
        <Modal
          data-testid='file-uploader-response-modal'
          trigger={(
            <Button
              data-testid='file-uploader-more-btn'
              as='a'
              style={{
                padding: 0, background: 'none', color: '#4183c4', cursor: 'pointer',
              }}
            >More
            </Button>
          )}
          header='Response Body'
          content={record.response}
          actions={[{
            key: 'done',
            content: 'Done',
            positive: true,
            'data-testid': 'file-uploader-done-btn',
          }]}
        />
      </div>
    );
  };

  const MaxResponseLength = 30;

  const {
    id,
    responseCode,
    response,
    jobProcessed,
    source,
    inputFile,
    status,
    fileName,
    fileType,
  } = allFiles;

  const replace = value => {
    return value === null || value === 'null' ? null : value.replace('_', '  ');
  };

  const getResponseBody = resp => {
    if (resp) {
      return resp.substring(0, MaxResponseLength);
    }
    return '';
  };

  const showModal = !isEmpty(response) && response.length > MaxResponseLength;
  const unwarningStatuses = ['processing', 'cancelled'];
  const showWarning = !(
    responseCode === '200'
    || (responseCode === null && unwarningStatuses.includes(status))
  );
  const responseShort = getResponseBody(response);

  return (
    <Table.Row negative={showWarning} key={id} textAlign='center'>
      <Table.Cell singleLine className='table-field'>
        <a href={inputFile}>
          <p>{fileName}</p>
        </a>
      </Table.Cell>
      <Table.Cell className='table-field'>
        <p>{fileType}</p>
      </Table.Cell>
      <Table.Cell className='table-field'>
        <p>{replace(source)}</p>
      </Table.Cell>
      <Table.Cell className='table-field'>
        {replace(status.toUpperCase())}
      </Table.Cell>
      <Table.Cell className='table-field'>
        {jobProcessed === true && (
          <Icon color='green' name='checkmark' size='large' />
        )}
        {jobProcessed === false && (
          <Icon color='red' name='close' size='large' />
        )}
      </Table.Cell>
      <Table.Cell className='table-field'>
        <p>{responseCode}</p>
      </Table.Cell>
      <Table.Cell className='table-field'>
        {responseShort}
        {isEmpty(response) && 'N/A'}
        {showModal && processResponse(allFiles)}
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
